import { render, staticRenderFns } from "./vsTab.vue?vue&type=template&id=b4de5d00&lang=html&"
import script from "./vsTab.vue?vue&type=script&lang=js&"
export * from "./vsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vsTab.vue"
export default component.exports